export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7646.ae7c0b43.jpg";